var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRf8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_874_625)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "url(#pattern0_874_625)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_874_625",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_874_625",
    transform: "scale(0.025641 0.0208333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_874_625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_874_625",
    width: 39,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAwCAQAAAA4eaudAAADVklEQVRIx9WXXUhUQRTHb/nfdTMNHwIpM5AwCiOpBJGyooiCwoegh4KISBRDSIoKkgSjhyBDNF/6MEEsSynEWJFEEhUrk3woM8HIpDStNjPXj3S9/Xf23t27m9Sd21N3cM4958z9Oc6cOWdUFMUWi6dQLbbvyFOCH9RhHEW4It26iOvkzxYDzBaFWZQoFh48QTeWYBqlRmMi+RmWcJ9Rxb4X9UZjAnHHLeEGcZ/9O9wzGsPxI8hgHtdAYALmUBBsLqGpEx3SbUjs7DhWBOHsdlyGi0vaKtnaRKg0zzfxfjTJ/rG2JMImMWG3hzri6TgvvXYn+FURVNvWUMfRkGA0h6vFFzGR/FBHBdy/TfkvT8pCrrcvUB6H4gbQKD23DZxXDuUtTEY5jI5VdJyTxp3kV4mUhym3Gx0ZNKRK4x5iRF1AGcevjYGM2xh32ORgMWEYRbX2fR9ajLiPaJCeWzLnlK2938B0xCLdsZqOs9K404y3tdr7IRJ26o4sOlKkcU4M+Q/BcuIu6o4qjMWEycGigDFvrvPDe9EWiDl/+kO297cgHeVider00MY2RtcjW1RQzGUZcNfwU9tMJqerhgzWy74UHva5XIR4Yc2FhwVAxUb/uH3UdhlwZzg21veqovhPOGwmyomcIFy6YfG1jUHcfDg36vGetnr0aLgWDDuiccQKrpjaIF6LNodvjgis92UMa7g4TKFGvO3QMPm++LKEE+s2h3LG+RumnyXUm+ASJ9MibhP1CRYUFTeF7vKFkVVcKvWDlKOoUJTwxdS6kWYdt5v6XhHctdpAF2ZwgYncEu4Ade9sXumVDZf021LgZJvHHeNnSZTteO4/QNP2SOznuD3yOP0siPMhLNX4FFhTWZw3zpZS1ugJCI3oYRJaY7wYmccVQvXmEZTBrVk60c4+huPy5HHXMSUkq7svC+ItnOIeo6JQHncXI0IWQHVEa4FcKaQbZfI4J/qEPEX7SlHrPb58iA94II9rRZeQmbSvUxSmJq2K4mXg8mAe98wXb974QzLXbJm+BXiBDnmc9yZah0reLF32SFGe+/EVd1jz5wyJzCyO/xaUcZWGeclP0yxJaKY+gDJD6TGLM1ll/1uch21Gsnmr7qxB9wTqbCZ389+b9KXJ1PMLWbENEJzmTG0AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRf8);
export default __webpack_public_path__ + "static/media/rf8.455909e978a85913749b3114619349e7.svg";
export { ForwardRef as ReactComponent };